import React, { useState, useEffect } from 'react';
import { Col, Row, Form, FormGroup, Input, Button, Card, CardBody, CardHeader, Spinner, Label } from 'reactstrap';
import ReadMoreContent from '../Utilities/Ui/ReadMore';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import './CatchmentContext.css';
import { toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Select from 'react-select';
import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const CatchmentOverview = () => {
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [saving, setSaving] = useState('');
    const [overviewDescription, setOverviewDescription] = useState('');
    const [culturalValuesDescription, setCulturalValuesDescription] = useState('');
    const [freshwaterValuesPrioritiesOutcomes, setFreshwaterValuesPrioritiesOutcomes] = useState('');
    const [overview, setOverview] = useState('');
    const [culturalValues, setCulturalValues] = useState('');
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const [priorityContaminantList, setPriorityContaminantList] = useState([]); const [priorityContaminantListSelectedValues, setPriorityContaminantListSelectedValues] = useState([]);
    const [priorityContaminantSelectedValues, setPriorityContaminantSelectedValues] = useState('');
    useEffect(() => {
        getOverview();

    }, [])

    const getOverview = async () => {
        try {
            const response = await apiGet('/api/catchmentContext/getCatchmentOverview/', {
                params: {
                    farmId: farmId
                }
            });

            setOverview(response?.data?.overview);
            setCulturalValues(response?.data?.culturalValues);
            setOverviewDescription(response?.data?.overviewDescription);
            setCulturalValuesDescription(response?.data?.culturalValuesDescription);
            setFreshwaterValuesPrioritiesOutcomes(response?.data?.freshwaterValuesPrioritiesOutcomes);
            setPriorityContaminantList(response?.data?.priorityContaminantList);

            if (response?.data?.selectedPriorityContaminantList.length > 0) {
                var priorityContaminantSelectedValues = '';
                response?.data?.selectedPriorityContaminantList.forEach(function (element) {
                    if (priorityContaminantSelectedValues == '') {
                        priorityContaminantSelectedValues = element.value;
                    }
                    else {
                        priorityContaminantSelectedValues = priorityContaminantSelectedValues + ',' + element.value;
                    }
                });
                setPriorityContaminantSelectedValues(priorityContaminantSelectedValues);
                setPriorityContaminantListSelectedValues(response?.data?.selectedPriorityContaminantList);
            }
            else {
                setPriorityContaminantListSelectedValues([]);
            }

        } catch (error) {
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message);
            } else {
                toast.error("No server response");
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        setSaving(true);
        var PriorityContaminants = priorityContaminantSelectedValues.toString();
        try {
            const response = await apiPost(
                '/api/catchmentContext/saveCatchmentOverview/',
                JSON.stringify(
                    {
                        overviewDescription, culturalValuesDescription, farmId, userId, freshwaterValuesPrioritiesOutcomes, PriorityContaminants,
                    }), {
                headers: { 'Content-Type': 'application/json' }
            });

            setTimeout(() => {
                setSaving(false);
            }, 1000)

            toast.success("Catchment Overview Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)

            if (!err?.response) {
                toast.error("No server response!");
            } else if (err.response?.status === 400) {
                toast.error("Saving Catchment Overview Details Failed!");
            } else {
                toast.error("Saving Catchment Overview Details Failed!");
            }
        }
    }

    const CatchmentInfo = () => (
        <div>
            <p>If you need more space in any of these just click on the small diagonal lines at the bottom right-hand side of the text box and drag the box down. It will expand to suit your needs. Remember to always hit Save when you’re done so you don’t lose any work.</p>
        </div>
    );
    const CatchmentInfoId = "CatchmentInfoId";
    const showCatchmentInfoMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CatchmentInfo, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: CatchmentInfoId, rtl: false
        });
    };

    const FrestwaterValues = () => (
        <div>
            <p>If you need more space in any of these just click on the small diagonal lines at the bottom right-hand side of the text box and drag the box down. It will expand to suit your needs. Remember to always hit Save when you’re done so you don’t lose any work.</p>
        </div>
    );
    const FrestwaterValuesId = "FrestwaterValuesId";
    const showFrestwaterValuesMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(FrestwaterValues, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: FrestwaterValuesId, rtl: false
        });
    };

    const handleChange = (e) => {
        setPriorityContaminantSelectedValues('');
        var priorityContaminantSelectedValues = '';
        setPriorityContaminantListSelectedValues(e);
        e.forEach(function (element) {
            if (priorityContaminantSelectedValues == '') {
                priorityContaminantSelectedValues = element.value;
            }
            else {
                priorityContaminantSelectedValues = priorityContaminantSelectedValues + ',' + element.value;
            }
        });
        setPriorityContaminantSelectedValues(priorityContaminantSelectedValues);
    }

    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <CardBody>
                <Form onSubmit={handleSubmit} >
                    <Row>
                        <Col sm="6">
                            <Card>
                                <CardHeader className="card-header-dark">
                                    <h5>Catchment Information&nbsp;&nbsp;&nbsp;
                                        <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-3" onClick={(e) => e.stopPropagation()} /></h5>
                                    <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                        id="my-tooltip-3"
                                        place="top"
                                        variant="info"
                                        render={({ content, activeAnchor }) => (
                                            <>
                                                <Row>
                                                    <Col>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            Click and drag the small diagonal lines at the bottom right-hand side for the text box to expand the box.
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    />
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <ReadMoreContent longText="Overview of the catchment including any areas that are sensitive to farming activities. Include biophysical characteristics such as soil, climate, freshwater data, and freshwater bodies. When considering the information provided by the Regional Council try to keep it in the context of your farm and what this may mean for your freshwater farm plan and where your actions should focus. If it doesn’t feel relevant don’t include it. This should also help to keep it brief." />
                                            <FormGroup>
                                                <Row className="mb-3">
                                                    <Col sm={12}>
                                                        <Input
                                                            id="overviewDescription"
                                                            name="overviewDescription"
                                                            type="textarea"
                                                            value={overviewDescription}
                                                            onChange={(e) => setOverviewDescription(e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="significantspecies">Catchment priority Contaminants</Label>
                                                <Select className="dropdown" placeholder="Select Option" value={priorityContaminantListSelectedValues} options={priorityContaminantList} onChange={handleChange} isMulti isClearable />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                        </Col>
                        <Col sm="6">
                            <Card>
                                <CardHeader className="card-header-dark">
                                    <h5 style={{ fontSize:"18.5px" }}>Freshwater Values, Priorities, or Outcomes&nbsp;&nbsp;&nbsp;
                                        <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-4" onClick={(e) => e.stopPropagation()} /></h5>
                                    <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                        id="my-tooltip-4"
                                        place="top"
                                        variant="info"
                                        render={({ content, activeAnchor }) => (
                                            <>
                                                <Row>
                                                    <Col>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            Click and drag the small diagonal lines at the bottom right-hand side for the text box to expand the box.
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    />
                                </CardHeader>
                                <CardBody>
                                    <ReadMoreContent longText="Include areas identified in applicable district or regional plans, iwi management plans, action plans under the National Policy Statement for Freshwater Manager, or other secondary legislation. When considering the information provided by the Regional Council try to keep it in the context of your farm and what this may mean for your freshwater farm plan and where your actions should focus. If it doesn’t feel relevant don’t include it. This should also help to keep it brief." />
                                    <FormGroup>
                                        <Row className="mb-3">
                                            <Col sm={12}>
                                                <Input
                                                    id="freshwaterValuesPrioritiesOutcomes"
                                                    name="freshwaterValuesPrioritiesOutcomes"
                                                    type="textarea"
                                                    value={freshwaterValuesPrioritiesOutcomes}
                                                    onChange={(e) => setFreshwaterValuesPrioritiesOutcomes(e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm="6" style={{ display: "none" }}>
                            <Card>
                                <CardHeader className="card-header-dark">
                                    <h5>Cultural Significance</h5>
                                </CardHeader>
                                <CardBody>
                                    <ReadMoreContent longText="Cultural Significance of the catchment, including Te Ao Maori values where appropriate                                                                                                       " />
                                    <FormGroup>
                                        <Row className="mb-3">
                                            <Col sm={12}>
                                                <Input
                                                    id="culturalValuesDescription"
                                                    name="culturalValuesDescription"
                                                    type="textarea"
                                                    value={culturalValuesDescription}
                                                    onChange={(e) => setCulturalValuesDescription(e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                        <>
                    {saving ?
                        <Button style={{ float: "right", marginTop: '10px' }}
                            color="success"
                            disabled
                        >
                            <Row>
                                <Col sm="8">
                                    <span>
                                        {' '}Saving
                                    </span>
                                </Col>
                                <Col sm="4">
                                    <Spinner size="sm">
                                        Saving...
                                    </Spinner>
                                </Col>
                            </Row>
                        </Button>
                        :
                        <Button style={{ float: "right", marginTop: '10px' }} color="success" size="sm">
                            Save
                        </Button>
                        }
                        </>
                    }
                </Form>
            </CardBody>
        </>
    )
}

export default CatchmentOverview